// extracted by mini-css-extract-plugin
export default {"noteList":"NoteList_noteList__pR4uV"};